import React from 'react';
import UpcomingPostsSkeleton from './UpcomingPostsSkeleton';
import StatsCardSkeleton from './StatsCardSkeleton';

const PageSkeleton = () => (
  <div className='space-y-6'>
    {/* Business Section Skeleton */}
    <div className='bg-gradient-to-r from-slate-100 via-slate-50 to-slate-200 rounded-xl p-6 text-slate-800 relative overflow-hidden border border-slate-200'>
      {/* Background Pattern */}
      <div className='absolute inset-0 opacity-10'>
        <div className='absolute top-0 right-0 w-64 h-64 bg-white rounded-full -translate-y-32 translate-x-32'></div>
        <div className='absolute bottom-0 left-0 w-48 h-48 bg-white rounded-full translate-y-24 -translate-x-24'></div>
      </div>

      <div className='relative'>
        {/* Header with Logo and Title */}
        <div className='flex items-start gap-4 mb-4'>
          {/* Logo Skeleton */}
          <div className='w-16 h-16 md:w-20 md:h-20 bg-slate-300 rounded-2xl flex-shrink-0'></div>

          {/* Title and Subtitle Skeleton */}
          <div className='flex-1 min-w-0 space-y-2'>
            <div className='h-8 bg-slate-300 rounded w-48 md:w-64'></div>
            <div className='h-5 bg-slate-300 rounded w-full max-w-md'></div>
          </div>
        </div>

        {/* Description Skeleton */}
        <div className='space-y-2 mb-3'>
          <div className='h-4 bg-slate-300 rounded w-full'></div>
          <div className='h-4 bg-slate-300 rounded w-3/4'></div>
        </div>

        {/* Tags Skeleton */}
        <div className='flex items-center gap-2'>
          <div className='h-6 bg-slate-300 rounded-full w-24'></div>
          <div className='h-6 bg-slate-300 rounded-full w-20'></div>
        </div>
      </div>
    </div>

    {/* Upcoming Posts Skeleton */}
    <UpcomingPostsSkeleton />

    {/* Stats Cards Skeleton */}
    <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6'>
      {[...Array(4)].map((_, index) => (
        <StatsCardSkeleton key={index} />
      ))}
    </div>
  </div>
);

export default PageSkeleton;
